<template>
  <div class="basic-information">
    <snow-input
      v-model="form.name"
      class="mb-6"
      label="Nome do produto *"
      :rules="rules.name"
    />

    <snow-input
      v-model="form.description"
      class="mb-6"
      type="textarea"
      label="Descrição *"
      :rows="3"
      :rules="rules.description"
    />

    <action-dispatcher action="product/getCategories">
      <snow-select
        v-model="form.category_id"
        required
        label="Categoria do produto para que seus compradores encontrem mais fácil *"
        :options="categories"
      />
    </action-dispatcher>

  </div>
</template>

<script>
import { required } from "@/functions/validation";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rules: {
        name: [required()],
        description: [required()]
      }
    };
  },
  computed: {
    ...mapState("product", ["categories"])
  },
  mounted() {
    this.$store.dispatch("product/getCategories").then();
  },
  watch: {
    form(val) {
      if (val.category) {
        this.form.category_id = val.category.id;
      }
    }
  },
};
</script>
